import React from 'react';

import Seo from '../ui/Seo';
import PageHero from '../sections/PageHero';
import TradeTicker from '../sections/TradeTicker';
import Pledge from '../sections/Pledge';
import StoryDeck from '../sections/StoryDeck';
import SectionHead from '../sections/SectionHead';
import Faqs from '../sections/Faqs';
import Cta from '../sections/Cta';

import EnergyAudits from "../media/images/energy-efficiency/energy-audits.jpg";
import LedLightingUpgrades from "../media/images/energy-efficiency/led-lighting-upgrades.jpg";
import SolarPowerIntegration from "../media/images/energy-efficiency/solar-power-integration.jpg";
import SmartEnergyManagement from "../media/images/energy-efficiency/smart-energy-management.jpg";
import HvacEfficiencyUpgrades from "../media/images/energy-efficiency/hvac-efficiency-upgrades.jpg";
import DemandResponseSystems from "../media/images/energy-efficiency/demand-response-systems.jpg";

const content =
[
    {
        title: "Energy Audits",
        text: "Analyze your property’s energy usage and identify areas for improvement. Our energy audits help reduce costs and increase efficiency.",
        imgSrc: EnergyAudits,
        alt: "Energy Audits - Smart Electric Solutions",
        focus: "50%",
    },
    {
        title: "LED Lighting Upgrades",
        text: "Switch to energy-efficient LED lighting to save on energy costs while enhancing the look and feel of your home or business.",
        imgSrc: LedLightingUpgrades,
        alt: "LED Lighting Upgrades - Energy Efficiency",
        focus: "20%",
    },
    {
        title: "Solar Power Integration",
        text: "Embrace renewable energy with seamless solar panel installations. Reduce your carbon footprint and energy bills simultaneously.",
        imgSrc: SolarPowerIntegration,
        alt: "Solar Power Integration - Renewable Energy",
        focus: "80%",
    },
    {
        title: "Smart Energy Management",
        text: "Optimize your energy usage with smart technologies that monitor and adjust consumption automatically for maximum efficiency.",
        imgSrc: SmartEnergyManagement,
        alt: "Smart Energy Management - Technology Solutions",
        focus: "50%",
    },
    {
        title: "HVAC Efficiency Upgrades",
        text: "Improve the energy efficiency of your heating and cooling systems with expert installations and upgrades.",
        imgSrc: HvacEfficiencyUpgrades,
        alt: "HVAC Efficiency Upgrades - Comfort and Savings",
        focus: "40%",
    },
    {
        title: "Demand Response Systems",
        text: "Optimize energy usage during peak demand periods with demand response systems. These smart systems automatically adjust power consumption, helping you save on energy costs while supporting a stable grid.",
        imgSrc: DemandResponseSystems,
        alt: "Demand Response Systems - Smart Energy Solutions",
        focus: "64%",
    }
];

export default function EnergyEfficiency() {
    return (
        <>
            <Seo
                title="Energy Efficiency"
                description="Energy audits, LED lighting upgrades, smart energy management, solar integration, HVAC efficiency and demand response for South Florida properties."
                keywords="energy audits, LED lighting upgrades, smart energy management, solar power integration, HVAC efficiency, demand response, South Florida"
                path="/energy-efficiency"
                schema={{
                    '@type': 'WebPage',
                    name: 'Energy Efficiency',
                    description: 'Energy audits, LED lighting upgrades, smart energy management, solar integration, HVAC efficiency and demand response for South Florida properties.',
                    url: 'https://smartelectric.solutions/energy-efficiency'
                }}
            />

            <PageHero
                eyebrow="Systems"
                title="Savings you can measure on a bill."
                lead="We audit what you actually consume before proposing anything, so the payback period on the work is a number rather than a hope."
                backdrop={content[0].imgSrc}
                focus={`${content[0].focus} center`}
                crumbs={[{ label: 'Systems' }, { label: 'Energy Efficiency' }]}
            />

            <TradeTicker />

            <section className="section section--tight">
                <div className="shell">
                    <Pledge />
                </div>
            </section>

            <section className="section section--ruled">
                <div className="shell">
                    <SectionHead
                        eyebrow="What we do"
                        title="Where the money goes."
                        lead="Lighting, HVAC, controls and generation, ranked by what each one returns on your building."
                    />
                </div>

                <div style={{ marginTop: 'clamp(2.5rem, 6vw, 4rem)' }}>
                    <StoryDeck items={content} />
                </div>
            </section>

            <Faqs />
            <Cta />
        </>
    );
}
